import { SweTopBar } from "common/src/component/SweTopBar";
import React, { useEffect, useState } from "react";
import { matchPath, useHistory, withRouter } from "common/src/router/compat";
import { useTranslation } from "react-i18next";
import { useLocation } from "common/src/router/compat";
import { useScrollPosition } from "common/src/helpers/useScrollPosition";
import Logo from "common/src/component/Logo";
import PlayerBalance from "common/src/component/PlayerBalance";
import { ThemeSwitcher } from "common/src/component/ThemeSwitcher";
import { isMobile, isTablet } from "react-device-detect";
import {
  BalanceWrapper,
  HeaderWrapper,
  LinkForDeposit,
  LinkToHome,
  StyledHeader,
  StyledHeaderLink,
} from "../styledComponents/StyledHeader";
import Time from "./Time";
import { getToken } from "../helpers/session";
import { StyledButton } from "../styledComponents/CommonStyledComponents";

import LanguageChange from "./LanguageChange";
import QuickGameCategories from "./QuickGameCategories";

const Header = ({
  serverSetup,
  currentTheme,
  setTheme,
  player,
  balance,
  pages,
  inGame,
  isOpen,
  setIsOpen,
  headerUserExpand,
  setHeaderUserExpand,
  sidepanel,
  gameCategories,
  skin,
  defaultLang,
  expandWallet,
  setExpandWallet,
  startDeposit,
}) => {
  let location = useLocation();
  const { t, i18n } = useTranslation("");
  const [hideOnScroll, setHideOnScroll] = useState(true);
  /*   const [scrollChecker, setScrollChecker] = useState(false); */
  const { country } = player;
  const { geoIP } = serverSetup;
  const isSWEIp =
    geoIP.isoCode.toLowerCase() === "se" || country === "se" ? true : false;
  const indexPage =
    useLocation().pathname.split("/")[2] === "index" ? true : false;
  const baseUrl = `/${i18n.language || window.localStorage.i18nextLng}`;
  const history = useHistory();
  useEffect(() => {
    location.pathname === pages["register"] ? setHideOnScroll(true) : null;
  }, [location.pathname === pages["register"]]);

  const notAccountRoute =
    location.pathname !== pages["my-account"] &&
    location.pathname !== pages["my-profile"] &&
    location.pathname !== pages["cashback"] &&
    location.pathname !== pages["bonuses"] &&
    location.pathname !== pages["change-password"] &&
    location.pathname !== pages["transactions"] &&
    location.pathname !== pages["casino-history"] &&
    location.pathname !== pages["my-limits"] &&
    location.pathname !== pages["complaints"] &&
    location.pathname !== pages["my-verification"];

  useScrollPosition(
    ({ currPos }) => {
      let isShow;
      if (isMobile && headerUserExpand && notAccountRoute) {
        isShow = Math.abs(currPos.y) < 500;
      } else if (isMobile && !headerUserExpand) {
        isShow = Math.abs(currPos.y) < 50;
      } else if (isMobile) {
        isShow = Math.abs(currPos.y) < 150;
      } else if (isTablet && headerUserExpand && notAccountRoute) {
        isShow = Math.abs(currPos.y) < 300;
      } else {
        isShow = Math.abs(currPos.y) < 70;
      }
      //console.log(currPos.y);
      if (isShow !== hideOnScroll) {
        if (currPos.y === 0) {
          setHideOnScroll(isShow);
        } else {
          setHeaderUserExpand(false);
          setHideOnScroll(isShow);
        }
      }
    },
    [(hideOnScroll, headerUserExpand)],
  );

  const scrollToTop = () => {
    setIsOpen(false);
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const handleClickOnNav = (goTo) => {
    if (goTo && goTo === "deposit" && location.pathname === pages["deposit"]) {
      // console.log("click on deposit button on deposit page, set step 0");
      window.top.postMessage(
        JSON.stringify({
          error: false,
          list: true,
        }),
        window.location.origin,
      );
    }
    setIsOpen(!isOpen);
    scrollToTop();
  };

  let checkLocation =
    location.pathname === `/${serverSetup.currentLanguage}/index` &&
    serverSetup.geoIP.isoCode === "SE" &&
    skin === "abc"
      ? true
      : false;

  let mobilePUB = (skin === "cac" || skin === "hyc") && isMobile;
  let mobileABC =
    (skin === "abc" ||
      skin === "yet" ||
      skin === "fun" ||
      skin === "qbc" ||
      skin === "bec" ||
      skin === "pub") &&
    isMobile;

  let checkPlayerMob = isMobile && !player;
  let showThemeSwticherMobABC =
    (skin === "abc" ||
      skin === "nbc" ||
      skin === "yet" ||
      skin === "fun" ||
      skin === "pub") &&
    isMobile &&
    player;

  const handleTriggerPnp = () => {
    sessionStorage.setItem("startPnpFromHeader", true);
    /* history.push(baseUrl + "/index"); */
    window.location = pages["index"];
  };

  return (
    <>
      {isSWEIp && <SweTopBar pages={pages} />}
      <HeaderWrapper
        hideOnScroll={hideOnScroll}
        player={player}
        liveAndSports={notAccountRoute}
      />
      <StyledHeader
        player={player}
        id="header"
        notAccountRoute={notAccountRoute}
        headerUserExpand={headerUserExpand}
        hideOnScroll={hideOnScroll}
        isSWEIp={isSWEIp}
        style={
          sidepanel
            ? {
                width: "calc(100% - 320px)",
                transition: "0.5s",
              }
            : { width: "100%", transition: "0s" }
        }
      >
        {notAccountRoute && (
            <QuickGameCategories
              expandedNav
              currentLanguage={serverSetup.currentLanguage}
              player={player}
              hideOnScroll={hideOnScroll}
              skin={skin}
              royalePage={pages["99royale"]}
              pages={pages}
            />
          )}
        {(skin === "fun" || skin === "cac" || skin === "hyc") && (
          <ThemeSwitcher
            currentTheme={currentTheme}
            setTheme={setTheme}
            player={player}
            skin={skin}
            server={serverSetup}
          />
        )}
        <>
          <Logo
            isSWEIp={isSWEIp}
            setOpen={setIsOpen}
            classOnScroll={hideOnScroll}
            defaultLang={defaultLang}
            player={player}
          />
        </>

        {/*{skin === "abc" && (*/}
        {/*    <QuickGameCategories />*/}
        {/*)}*/}
        {skin === "pub" && isMobile && (
          <LinkToHome
            onClick={() =>
              indexPage ? scrollToTop() : history.push(baseUrl + "/index")
            }
          ></LinkToHome>
        )}
        <BalanceWrapper player={player}>
          <Time player={player} skin={skin} server={serverSetup} />
          {showThemeSwticherMobABC
            ? null
            : (skin === "abc" || skin === "pub") && (
                <ThemeSwitcher
                  currentTheme={currentTheme}
                  setTheme={setTheme}
                  player={player}
                  skin={skin}
                  server={serverSetup}
                />
              )}
          {(skin === "yet" ||
            skin === "fun" ||
            skin === "cac" ||
            skin === "hyc") &&
            !player && <LanguageChange serverSetup={serverSetup} />}
          {player ? (
            balance && (
              <PlayerBalance
                player={player}
                serverSetup={serverSetup}
                balance={balance}
                headerUserExpand={headerUserExpand}
                setHeaderUserExpand={setHeaderUserExpand}
                skin={skin}
                hideOnScroll={hideOnScroll}
                expandWallet={expandWallet}
                setExpandWallet={setExpandWallet}
              />
            )
          ) : (
            <StyledHeaderLink
              to={pages["login"]}
              deposit="true"
              checklocation={checkLocation ? 1 : 0}
              onClick={() => handleClickOnNav()}
              login="true"
            >
              {t("label_login", "login")}
            </StyledHeaderLink>
          )}

          {player ? (
            mobilePUB || mobileABC ? null : (
              <StyledHeaderLink
                prime={skin === "pub" || skin === "cac" || skin === "hyc"}
                to={pages["deposit"]}
                onClick={() => handleClickOnNav("deposit")}
                deposit="true"
              >
                {t("label_deposit", "Deposit")}
              </StyledHeaderLink>
            )
          ) : (
            <StyledHeaderLink
              login="true"
              prime="true"
              register="true"
              checklocation={checkLocation ? 1 : 0}
              to={pages["register"]}
              dangerouslySetInnerHTML={{
                __html: t("label_register", "register"),
              }}
              onClick={() => handleClickOnNav()}
            ></StyledHeaderLink>
          )}
        </BalanceWrapper>
      </StyledHeader>
    </>
  );
};

export default withRouter(Header);
